/**
=========================================================
* Arakan - v2.1.0
=========================================================

* Product Page: https://www.trakib.com/product/material-dashboard-pro-react
* Copyright 2022 Trakib (https://www.trakib.com)

Coded by www.trakib.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Arakan components
import MDBox from "components/MDBox";

// Settings page components
import Header from "cruds/user-profile/components/Header";
import BasicInfo from "cruds/user-profile/components/BasicInfo";
import ChangePassword from "cruds/user-profile/components/ChangePassword";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import AuthService from "services/auth-service";
import getId from "services/helper-service";
import Footer from "examples/Footer";

function UserProfile() {
  const [user, setUser] = useState({
    id: "",
    name: "",
    email: "",
    password: "",
    newPassword: "",
    currentPassword: "",
    confirmPassword: "",
    profile_image: "",
  });

  const baseUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    (async () => {
      const response = await AuthService.getProfile();
      if (
        getId(response.data.id) == 1 ||
        getId(response.data.id) == 2 ||
        getId(response.data.id) == 3
      ) {
      }
      setUser((prevUser) => ({
        ...prevUser,
        id: response.data.id,
        name: `${response.data.first_name} ${response.data.last_name}`,
        first_name: response.data.first_name,
        last_name: response.data.last_name,
        profile_image: response.data.avatar
          ? `${baseUrl}assets/${response.data.avatar}`
          : null,
        email: response.data.email,
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      }));
    })();
  }, []);

  return (
    <DashboardLayout>
      {/* <DashboardNavbar /> */}
      <MDBox mt={4}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={9}>
            <MDBox mb={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Header user={user} />
                </Grid>
                <Grid item xs={12}>
                  <BasicInfo user={user} />
                </Grid>
                <Grid item xs={12}>
                  <ChangePassword user={user} />
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default UserProfile;
